import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from './Layout';
import { useAuth } from '../contexts/AuthContext';
import IngresosCharly from './IngresosCharly';
import AlfaTango1 from './AlfaTango1';
import AlfaTango2 from './AlfaTango2';
import Tango3 from './Tango3';

/* Mapeo catálogo → pantalla (no mezclar productos):
 * - Alfa Tango 1: Visita + Funcionarios → solo `alfa_tango_1` → AlfaTango1.
 * - Alfa Tango 2: Servicios + Gabetas → `alfa_tango_2` → AlfaTango2.
 * - Alfa Tango 3: solo `alfa_tango_3` → Tango3.
 */
const BitacoraPersonalizada = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const state = location.state || {};
  const codigo = (state.codigo || '').toLowerCase();
  const nombre = state.nombre || 'Bitácora personalizada';

  useEffect(() => {
    if (user && user.rol !== 'V') {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  if (user && user.rol !== 'V') {
    return null;
  }

  if (codigo === 'ingresos_charly') {
    return <IngresosCharly />;
  }
  if (codigo === 'alfa_tango_1') {
    return <AlfaTango1 />;
  }
  if (codigo === 'alfa_tango_2') {
    return <AlfaTango2 />;
  }
  if (codigo === 'alfa_tango_3') {
    return <Tango3 />;
  }

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 text-center shadow-sm">
          <p className="text-amber-700 font-semibold text-lg mb-2">En desarrollo</p>
          <p className="text-gray-700 text-sm">
            La opción <strong>{nombre}</strong>
            {codigo && (
              <span> (código: <strong>{codigo}</strong>)</span>
            )} está en desarrollo y estará disponible próximamente.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default BitacoraPersonalizada;
